export const handleDownloadTemplateHelper = (title) => {
  const file = `${title.replace(/\s+/g, '').toLowerCase()}.xlsx`;
  const url = `${process.env.REACT_APP_SPACES_UPLOAD}/dev/loadtemplates/${file}`;
  try {
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', file);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    console.error('Failed to download template', err);
  }
};

export default handleDownloadTemplateHelper;
